import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import {
  g2CustomerOrUserSignupParams,
  verifyUserRequest,
} from "../../redux/signup/action";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import background_image from "./../../assets/png/background_image.png";
import {
  updateInviteDriverDetails,
  updatePasswordDetails,
} from "../../redux/verifyUser/action";
import CustomLoader from "../../components/CustomLoader";

// let BRANCH_KEY = "";
// const nonProdEnv = ["qa", "dev", "localhost"];
// if (window.location.href.includes("reserve.safetruckparking.com")) {
// 	BRANCH_KEY = "key_live_aAgt7iLLUj7M6BUJtis0ygiayuiw9VDX";
// } else if (nonProdEnv.some((env) => window.location.href.includes(env))) {
// 	BRANCH_KEY = "key_test_oFdDWiVMPj3Q1AVOumv9xgahzvat9GSb";
// }

const VerifyUser = (props) => {
  const [isLoading, setLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyExtractUserEmail = new URLSearchParams(window.location.search);
    const URLString = verifyExtractUserEmail.toString();
    var search = location.search.substring(1);
    const requestParams = JSON.parse(
      '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
          .replace("%40", "@") +
        '"}',
    );
    if (verifyExtractUserEmail.get("flowtype") === "verifyemail") {
      dispatch(
        verifyUserRequest(URLString, (reseponseData) => {
          setLoading(false);
          if (
            reseponseData.status === "VALID" ||
            reseponseData.status === "AREADY_VERIFIED"
          )
            navigate("/login");
          else navigate("/signup");
        }),
      );
    } else if (verifyExtractUserEmail.get("flowtype") === "resetpassword") {
      setLoading(false);
      dispatch(updatePasswordDetails(requestParams));
      navigate("/forgot_password");
    } else if (verifyExtractUserEmail.get("flowtype") === "addoperator") {
      setLoading(false);
      dispatch(updateInviteDriverDetails(requestParams));
      navigate("/operatorAccountDetails");
    } else if (
      (verifyExtractUserEmail.get("flowtype") === "inviteCustomer" &&
        verifyExtractUserEmail.get("source") === "G2__") ||
      (verifyExtractUserEmail.get("flowtype") === "inviteOperator" &&
        verifyExtractUserEmail.get("source") === "G2__")
    ) {
      let customerPhone = requestParams?.phone?.split("__;")[0];

      let updatedRequestParams = requestParams;
      updatedRequestParams.phone = customerPhone.slice(-10);

      console.log(
        "customer signup params from g2 portal:",
        updatedRequestParams,
      );
      setLoading(false);
      dispatch(g2CustomerOrUserSignupParams(updatedRequestParams));
      navigate("/signup");
    } else if (
      verifyExtractUserEmail.get("flowtype") === "inviteCustomer" ||
      verifyExtractUserEmail.get("flowtype") === "inviteOperator"
    ) {
      let customerPhone = requestParams?.phone?.split("__;")[0];

      let updatedRequestParams = requestParams;
      updatedRequestParams.phone = customerPhone.slice(-10);

      console.log(
        "customer signup params from g2 portal:",
        updatedRequestParams,
      );
      setLoading(false);
      dispatch(g2CustomerOrUserSignupParams(updatedRequestParams));
      navigate("/signup");
    }
  }, []);

  return (
    <Container
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        position: "relative",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    >
      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default VerifyUser;
